<template>
  <el-form
    ref="form"
    label-position="top"
    :model="form"
    :rules="rules"
    @submit.native.prevent="submit"
  >
    <h1>Als Coach registrieren</h1>

    <h2>Persönliche Daten</h2>
    <c-account-form-coach-personal :form="form" />

    <h2>Qualifizierung</h2>
    <c-account-form-coach-skills :form="form" />

    <el-button
      :loading="submitStatus === $config.status.LOADING"
      native-type="submit"
      round
      type="primary"
    >
      Profil anlegen
    </el-button>
  </el-form>
</template>

<script>
import CAccountFormCoachPersonal from '@/components/CAccountFormCoachPersonal'
import CAccountFormCoachSkills from '@/components/CAccountFormCoachSkills'

import api from '@/api'
import validators from '@/functions/validators'

export default {
  name: 'VSignupCoach',

  metaInfo: {
    title: 'Als Coach registrieren'
  },

  components: {
    CAccountFormCoachPersonal,
    CAccountFormCoachSkills
  },

  data () {
    return {
      submitStatus: this.$config.status.IDLE,
      form: {
        firstName: '',
        lastName: '',
        phone: '',
        phoneMobile: '',
        address: '',
        postalCode: '',
        city: '',
        image: null,
        documentsTraining: null,
        documentsCertificate: null,
        compensation: null,
        website: '',
        coreArea: '',
        membershipsBvc: false,
        membershipsBvs: false,
        membershipsOther: false
      },
      rules: {
        firstName: {
          required: true,
          message: 'Bitte geben Sie Ihren Vornamen ein.'
        },
        lastName: {
          required: true,
          message: 'Bitte geben Sie Ihren Nachnamen ein.'
        },
        phone: [
          {
            required: true,
            message: 'Bitte geben Sie Ihre Telefonnummer ein.'
          },
          {
            validator (rule, value, callback) {
              validators.phoneNumber({
                value,
                message: 'Bitte geben Sie nur Zahlen und Sonderzeichen ein – keine Buchstaben.',
                callback
              })
            }
          }
        ],
        phoneMobile: {
          validator (rule, value, callback) {
            validators.phoneNumber({
              value,
              message: 'Bitte geben Sie nur Zahlen und Sonderzeichen ein – keine Buchstaben.',
              callback
            })
          }
        },
        address: {
          required: true,
          message: 'Bitte geben Sie Ihre Straße und Hausnummer ein.'
        },
        postalCode: {
          required: true,
          message: 'Bitte geben Sie Ihre Postleitzahl ein.',
          pattern: /^\d{5}$/
        },
        city: {
          required: true,
          message: 'Bitte geben Sie Ihren Ort ein.'
        },
        image: [
          {
            required: true,
            message: 'Bitte wählen Sie ein Foto aus.',
            trigger: 'none'
          },
          {
            validator (rule, value, callback) {
              validators.fileType({
                value,
                accept: ['image/jpeg', 'image/png', 'image/bmp', 'image/gif'],
                message: 'Bitte wählen Sie eine Bilddatei aus.',
                callback
              })
            },
            trigger: 'none'
          }
        ],
        documentsTraining: [
          {
            required: true,
            message: 'Bitte wählen Sie Ihre Ausbildungsunterlagen aus.',
            trigger: 'none'
          },
          {
            validator (rule, value, callback) {
              validators.fileType({
                value,
                accept: ['application/pdf'],
                message: 'Bitte wählen Sie eine PDF-Datei aus.',
                callback
              })
            },
            trigger: 'none'
          }
        ],
        documentsCertificate: [
          {
            required: true,
            message: 'Bitte wählen Sie Ihr Zertifikat aus.',
            trigger: 'none'
          },
          {
            validator (rule, value, callback) {
              validators.fileType({
                value,
                accept: ['application/pdf'],
                message: 'Bitte wählen Sie eine PDF-Datei aus.',
                callback
              })
            },
            trigger: 'none'
          }
        ],
        compensation: {
          required: true,
          type: 'number',
          min: 0,
          message: 'Bitte geben Sie Ihre Vergütung ein.'
        },
        website: {
          required: true,
          type: 'url',
          message: 'Bitte geben Sie eine gültige URL ein.'
        },
        coreArea: [
          {
            required: true,
            message: 'Bitte geben Sie Ihre thematischen Schwerpunkte ein.'
          },
          {
            max: 2000,
            message: 'Bitte schreiben Sie nicht mehr als 2.000 Zeichen.'
          }
        ]
      }
    }
  },

  methods: {
    submit () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }

        this.submitStatus = this.$config.status.LOADING

        api.signup
          .createCoach(this.form)
          .then(response => {
            this.submitStatus = this.$config.status.SUCCESS
            this.$router.push({ name: 'signup-pending' })
          })
          .catch(() => {
            this.$notify.error({
              title: 'Fehler',
              message: 'Ihr Profil konnte leider nicht angelegt werden.'
            })

            this.submitStatus = this.$config.status.ERROR
          })
      })
    }
  }
}
</script>
